import React, { useEffect, useRef, useState } from "react";
import { Text } from "components";
import { useNavigate } from "react-router-dom";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import axios from "axios";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, Legend, Pie, PieChart, } from "recharts";
import AccessRightCard from "pages/AccessRight/AccessRightCard";
import { MdCurrencyRupee } from "react-icons/md";
import PieChartSkeleton from "components/PageSkeleton/PieChartSkeleton";
import CustomTooltip from "components/Graphs/CustomTooltip";
import CustomLegend from "components/Graphs/CustomLegend";
pdfMake.vfs = pdfFonts.pdfMake?.vfs;

const DailyOpdRevenueReport = () => {
  const navigate = useNavigate();
  const [doclist, setdoclist] = useState([]);
  const [DoctorName, setDoctorName] = useState("All");
  const [paymentTypeId, setPaymentTypeId] = useState(0);
  const [user, setuser] = useState({});
  const [consultant, setConsultant] = useState(0);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modewiseData, setmodewiseData] = useState([]);
  const [itemwiseTotalOpdCollection, setItemwiseTotalOpdCollection] = useState([]);
  const [dataforbargraph, setDataforbargraph] = useState([]);
  const today = new Date();
  const todayFormatted = today.toISOString().split("T")[0];
  const chartHeight = Math.max(dataforbargraph.length * 40, 150);
  const [userList, setuserlist] = useState([]);

  // start date and end date 
  const [startdate, setStartdate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [enddate, setEnddate] = useState(
    new Date().toISOString().split("T")[0],
  );

  const now = new Date();
  //  for date formatting
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options).replace(",", "");
  };
  // for time formatting
  const formatTime = (date) => {
    const hours = date.getHours() % 12 || 12;
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = date.getHours() >= 12 ? "PM" : "AM";
    return `${hours}:${minutes} ${ampm}`;
  };
  const selectedconsultant = (e) => {
    setConsultant(e.value);
  }
  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const gridRef = useRef();

  // Download Pdf
  const DownloadPDF = () => {

    // if grid is empty it can give error so thats why we use this function
    if (!gridRef.current) {
      console.log("Grid not ready yet");
      return;
    }
    const rowData = [];

    // Get data from AG Grid
    gridRef.current.api.forEachNodeAfterFilterAndSort((node) => {
      rowData.push(node.data);
    });

    // Convert rows for PDF table
    const tableRows = rowData.map((row) => [
      { text: row.fee_type_name || "-" },
      { text: row.total_fee !== undefined ? row.total_fee.toString() : "-" }
    ]);

    const docDefinition = {
      pageOrientation: "portrait",

      content: [

        {
          text: "OPD Revenue Report",
          alignment: "center",
          fontSize: 18,
          bold: true,
          margin: [0, 10]
        },

        {
          canvas: [
            { type: "line", x1: 0, y1: 0, x2: 520, y2: 0, lineWidth: 1 }
          ],
          margin: [0, 5]
        },

        {
          columns: [
            { text: `Start Date : ${startdate}` },
            { text: `End Date : ${enddate}` },
            { text: `Consultant : ${DoctorName}` }
          ],
          margin: [0, 10]
        },

        {
          text: `Total OPD Collection : ₹ ${total}`,
          alignment: "center",
          fontSize: 14,
          bold: true,
          margin: [0, 10]
        },

        {
          text: "OPD Collection",
          fontSize: 14,
          bold: true,
          margin: [0, 10]
        },

        {
          table: {
            widths: ["*", 120],
            body: [
              [
                { text: "Procedure Name", style: "tableHeader" },
                { text: "Amount (₹)", style: "tableHeader" }
              ],
              ...tableRows
            ]
          },

          layout: {
            fillColor: (rowIndex) => (rowIndex === 0 ? "#CCCCCC" : null)
          }
        }

      ],

      styles: {
        tableHeader: {
          bold: true,
          fontSize: 11
        }
      }
    };

    pdfMake.createPdf(docDefinition).download("OPD_Revenue_Report.pdf");
  };

  // Api for user detail
  const getuser = () => {
    axios
      .post("/api/doctor/userdetail/get", {}, headers)
      .then((response) => {
        setuser(response?.data[0]);
        // console.log(response.data);
      })
      .catch(() => {
        console.log("Error");
      });
  };
  useEffect(() => {
    getuser();
  }, []);

  // api for al consultants

  const getAllConsultant = () => {
    axios
      .post("/api/doctor/userdetail/getAll", {}, headers)
      .then((response) => {
        const filteruserlist = response.data.filter(
          (user) => user.user_type_id === 2,
        );

        setuserlist(filteruserlist);
        console.log(filteruserlist);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Something went wrong");
      });
  };
  useEffect(() => {
    getAllConsultant();
  }, []);

  //   api for myreports and payment type summary
  const getData = () => {
    console.log("get data function call");
    setLoading(true)
    axios
      .post(
        "/api/doctor/my_report/getOpdReport",
        {
          startDate: startdate,
          endDate: enddate,
          consultantId: consultant > 0 ? consultant : null,
          paymentTypeId: paymentTypeId > 0 ? paymentTypeId : null,
        },
        headers,
      )
      .then((response) => {
        setData(response?.data.myReport || []);
        setmodewiseData(response?.data.paymentTypeSummary || []);
        setLoading(false);
      })
      .catch(() => {
        console.log("Error");
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  //   to load data 
  useEffect(() => {
    getData();
  }, [startdate, enddate, consultant]);

  //   data for piechart
  const paymentModeData = modewiseData.map((item) => ({
    name: item.payment_type,
    value: Number(item.total_paid_amount)
  }))
  console.log("paymentModeData");
  console.log(paymentModeData);

  useEffect(() => {
    // Retrieving data from sessionStorage
    const storeddoclist = sessionStorage.getItem("docAccesslist");

    if (storeddoclist) {
      try {
        // Parsing the JSON string to an array of objects
        const parseddoclist = JSON.parse(storeddoclist);
        setdoclist(parseddoclist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);

  const showActionColumn = doclist.some(
    (item) => item.hospital_module_id == 33 && item.view,
  );


  // colors for piechart
  const COLORS = [
    "url(#cashGrad)",
    "url(#upiGrad)",
    "url(#cardGrad)",
    "url(#insuranceGrad)",
    "url(#mobileGrad)",
    "url(#chequeGrad)",
    "url(#neftGrad)"
  ];


  //   total amount
  const total = paymentModeData.reduce((sum, item) => sum + item.value, 0);
  //   custom legend
  // const CustomLegend = ({ payload }) => {
  //   return (
  //     <div className="flex flex-col gap-y-2    text-xs">
  //       {payload.map((entry, index) => (
  //         <div key={index} className="flex items-center justify-between w-45  ">

  //           <div className="flex items-center  ">

  //             {/* gradient circle */}
  //             <svg width="12" height="12">
  //               <circle
  //                 cx="6"
  //                 cy="6"
  //                 r="5"
  //                 fill={COLORS[index]}
  //               />
  //             </svg>

  //             {/* label */}
  //             <span className="text-black">{entry.value}</span>
  //           </div>

  //           {/* value */}
  //           <span className="text-gray-700 ml-5 ">
  //             {((entry.payload.value / total) * 100).toFixed(1)}%
  //           </span>

  //         </div>
  //       ))}
  //     </div>
  //   );
  // };

  //  api for item wise total opd collection 
  const getItemwiseTotalOpdCollection = () => {
    axios
      .post(
        "/api/doctor/report/hospital/fee_distribution/buissness/get",
        { from_date: startdate, to_date: enddate, userdetail_id: consultant },
        headers
      )
      .then((response) => {
        // for aggrid
        setItemwiseTotalOpdCollection(response.data);
        // for bargraph 
        const formattedData = response.data.map((item) => ({
          name: item.fee_type_name,
          total_fee: item.total_fee
        }));

        setDataforbargraph(formattedData);
        console.log("itemwiseTotalOpdCollection");
        console.log(itemwiseTotalOpdCollection);
      })
      .catch(() => {
        console.log("Error");
      });
  };

  // column data for AGgrid 
  useEffect(() => {
    console.log("Consultant changed:", consultant);
    getItemwiseTotalOpdCollection();
  }, [startdate, enddate, consultant]);

  const [itemwiseColumnDefs] = useState([
    {
      headerName: "PROCEDURE NAME",
      field: "fee_type_name",
      flex: 1,
      minWidth: 200,
    },
    {
      headerName: "AMOUNT (Rs)",
      field: "total_fee",
      width: 180,
    }
  ]);

  // row data for AGgrid
  const itemwiseRowData = itemwiseTotalOpdCollection.map((item, index) => ({
    ...item,
    sr: index + 1
  }));

  const gridHeight = Math.max(itemwiseRowData.length * 45 + 60, 150);


  return (
    <>
      {showActionColumn ? (
        <div className="w-full flex flex-col gap-1 bg-[#f4f6ff]">
          <ToastContainer />
          {/* filter section */}
          <div className="filter-section ">
            {/* start date */}
            <div>
              <label className="filter-section-label">Start Date</label>
              <input
                type="date"
                value={startdate}
                onChange={(e) => setStartdate(e.target.value)}
                className="filter-section-input"
                max={todayFormatted}
              />
            </div>
            {/* End date */}
            <div >
              <label className="filter-section-label">End Date</label>
              <input
                type="date"
                value={enddate}
                onChange={(e) => setEnddate(e.target.value)}
                className="filter-section-input"
                max={todayFormatted}
              />
            </div>

            {/* Consultant */}
            {/* Select Consultant */}
            <div >
              <Text
                className=" filter-section-label"
              >
                <span >
                  Select Consultant
                </span>
              </Text>

              <Select
                name="userdetail_id"
                options={[
                  { label: "All", value: 0 }, // Adding the "All Consultants" option
                  ...(userList?.map((resstate) => ({
                    label: resstate.name,
                    value: resstate.id,
                  })) ?? []),
                ]}
                classNamePrefix="filter-custom-select"
                onChange={(selectedOption) => {
                  setConsultant(selectedOption.value);
                  setDoctorName(selectedOption.label);
                  // console.log(`in select ${DoctorName}`);

                }}
                placeholder="All"
              />
            </div>

            {/* Buttons */}
            <div className="">
              <button
                //  disabled={!gridRef.current.api}
                onClick={() => {
                  if (enddate < startdate) {
                    toast.error("End date cannot be before Start date");
                    return;
                  }
                  if (!gridRef.current || gridRef.current.api.getDisplayedRowCount() === 0) {
                    toast.error("No data available to export");
                    return;
                  }

                  DownloadPDF();
                }}
                // disabled={userList.length === 0}
                className="btn-secondary mt-5"
              >
                Export To PDF
              </button>
            </div>
            {/* <div>
              <button
                onClick={() => {
                  if (modewiseData.length > 0) {
                    generateExcel(data, modewiseData, user, now);
                  } else {
                    toast.error("Generate Report First");
                  }
                }}
                className="btn-primary mt-4"
              >
                Download
              </button>
            </div> */}
          </div>
          <hr className="border" />

          {/* main body*/}
          <div className="flex flex-row mx-6 my-2  w-full justify-evenly gap-4 ">
            {/* left section */}
            <div className="flex flex-col w-[50%] ">
              {/* OPD Collection */}
              <div className="flex flex-col items-center h-[12vh] p-2 custom-box">
                <div className="flex items-center  ">
                  <div className=" w-20  border-t border-gray-700"></div>

                  <span className="mx-4 text-[18px]  text-gray-800 font-medium">
                    Total OPD Collection
                  </span>

                  <div className=" w-20 border-t border-gray-700"></div>
                </div>
                {
                  loading ? (
                    <div className=" mt-2 flex flex-row text-nowrap font-bold text-[25px] items-center justify-center">
                      <MdCurrencyRupee className="" />
                    </div>
                  )
                    : (
                      <div className="mt-2 flex flex-row text-nowrap font-bold text-[25px] items-center justify-center">
                        <MdCurrencyRupee className="" />
                        <Text className="  " >
                          {total.toFixed(2)}
                          {/* 76435790075424 */}
                        </Text>
                      </div>
                    )
                }

              </div>
              {/* total OPD Collection*/}
              <div className="flex flex-col mt-3 mb-5 custom-box">
                <div className="flex items-center justify-start text-[16px] font-bold pl-7 pt-3">
                  <Text>OPD Collection</Text>
                </div>
                <hr className="border border-gray-300 mt-3 mx-3" />
                <div className=" p-3 ag-theme-alpine  w-full  "
                  style={{ height: gridHeight }}>
                  {
                    loading ? (<div className="space-y-2 animate-pulse {{ height: gridHeight }}">
                      {[...Array(3)].map((_, i) => (
                        <div key={i} className="flex justify-between items-center space-x-3 mt-5 ">

                          {/* left label */}
                          <div className="h-7 w-[60%] bg-gray-300 rounded"></div>

                          {/* Total amount */}
                          <div className="h-7 w-[40%] bg-gray-300 rounded"></div>

                        </div>
                      ))}
                    </div>) : (
                      <AgGridReact
                        ref={gridRef}
                        rowData={itemwiseRowData}
                        columnDefs={itemwiseColumnDefs}
                      />
                    )
                  }

                </div>
              </div>
            </div>
            {/* right section */}
            <div className=" flex flex-col w-[50%] ">
              {/* Payment Mode */}
              <div className=" custom-box w-[90%]  p-3">
                <div className="flex items-center justify-start">
                  <Text className="pl-6 text-[16px] font-bold ">
                    Payment Mode
                  </Text>
                </div>
                <hr className="border border-gray-300 mt-2" />
                {
                  loading ? (<PieChartSkeleton />)
                    : (
                      <div className="flex items-center ">
                        <ResponsiveContainer width={500} height={210} >
                          <PieChart >
                            <defs>
                              <linearGradient id="cashGrad" x1="0" y1="0" x2="1" y2="1">
                                <stop offset="0%" stopColor="#66BB6A" />
                                <stop offset="100%" stopColor="#2E7D32" />
                              </linearGradient>

                              <linearGradient id="upiGrad" x1="0" y1="0" x2="1" y2="1">
                                <stop offset="0%" stopColor="#42A5F5" />
                                <stop offset="100%" stopColor="#1565C0" />
                              </linearGradient>

                              <linearGradient id="cardGrad" x1="0" y1="0" x2="1" y2="1">
                                <stop offset="0%" stopColor="#4FC3F7" />
                                <stop offset="100%" stopColor="#0288D1" />
                              </linearGradient>

                              <linearGradient id="insuranceGrad" x1="0" y1="0" x2="1" y2="1">
                                <stop offset="0%" stopColor="#FFA726" />
                                <stop offset="100%" stopColor="#EF6C00" />
                              </linearGradient>

                              <linearGradient id="mobileGrad" x1="0" y1="0" x2="1" y2="1">
                                <stop offset="0%" stopColor="#BA68C8" />
                                <stop offset="100%" stopColor="#6A1B9A" />
                              </linearGradient>

                              <linearGradient id="chequeGrad" x1="0" y1="0" x2="1" y2="1">
                                <stop offset="0%" stopColor="#EF5350" />
                                <stop offset="100%" stopColor="#B71C1C" />
                              </linearGradient>

                              <linearGradient id="neftGrad" x1="0" y1="0" x2="1" y2="1">
                                <stop offset="0%" stopColor="#4DD0E1" />
                                <stop offset="100%" stopColor="#006064" />
                              </linearGradient>
                            </defs>
                            <Pie
                              data={paymentModeData}
                              dataKey="value"
                              nameKey="name"
                              cx="50%"
                              cy="50%"
                              outerRadius={90}
                              label={({ percent, x, y }) => (
                                <text
                                  x={x}
                                  y={y}
                                  fill="black"
                                  fontSize="12"
                                  fontWeight="bold"
                                  textAnchor="middle"
                                  dominantBaseline="central"
                                >
                                  {(percent * 100).toFixed(1)}%
                                </text>
                              )}
                              labelLine={false}
                            >
                              {paymentModeData.map((entry, index) => (
                                <Cell key={index} fill={COLORS[index % COLORS.length]} />
                              ))}
                            </Pie>

                            <Tooltip content={<CustomTooltip />} />

                            <Legend
                              content={<CustomLegend COLORS={COLORS} total={total} />}
                              layout="vertical"
                              align="right"
                              verticalAlign="middle"
                            />

                          </PieChart>
                        </ResponsiveContainer>
                      </div>
                    )
                }



              </div>
              {/* Department wise data */}



              {
                loading ?
                  (<div className="flex flex-col my-3 w-[100%] custom-box p-2">
                    <div className="space-y-2 ml-10 animate-pulse {{ height: gridHeight }}">
                      {[...Array(4)].map((_, i) => (
                        <div key={i} className="flex justify-between items-center space-x-3 mt-5 ">

                          {/* left label */}
                          <div className="h-7 w-[90%] bg-gray-300 rounded"></div>

                        </div>
                      ))}
                    </div>
                  </div>
                  ) : (
                    <div className="flex flex-col my-3 w-[90%] custom-box p-2">
                      <div className="flex items-center justify-start">
                        <Text className=" text-[16px] font-bold ">
                          Item Wise
                        </Text>
                      </div>
                      <hr className="border border-gray-300 mt-3 mx-3" />
                      <ResponsiveContainer width="100%" height={chartHeight}>
                        <BarChart
                          data={dataforbargraph}
                          layout="vertical"
                          barSize={15}
                        >
                          <defs>
                            <linearGradient id="upiGrad" x1="0" y1="0" x2="1" y2="1">
                              <stop offset="0%" stopColor="#42A5F5" />
                              <stop offset="100%" stopColor="#1565C0" />
                            </linearGradient>
                          </defs>
                          <XAxis type="number" hide />
                          <YAxis
                            type="category"
                            dataKey="name"
                            width={120}
                          />

                          <Tooltip content={<CustomTooltip />} />

                          <Bar dataKey="total_fee" stackId="a" fill="url(#upiGrad)" />
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                  )
              }

            </div>
          </div>
        </div>

      ) : (
        <AccessRightCard />
      )}
    </>
  );
};

export default DailyOpdRevenueReport;
